import { render } from "./HeaderAccount.vue?vue&type=template&id=1b64de96"
import script from "./HeaderAccount.vue?vue&type=script&lang=js"
export * from "./HeaderAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__